<template>
	<div class="body" v-loading="loading" element-loading-text="分析项目初始化中，预计需要3-5分钟左右，请耐心等待，谢谢！">
		<div class="body-container">
			<!-- 用 v-md-preview 替代 v-html -->
			<VMdPreview :text="fullContent" ref="preview"></VMdPreview>
		</div>

		<div class="action-ctr" v-if="isDone">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">下载报告</el-button>
		</div>
	</div>
</template>

<script>
	import aiChatService from '@/utils/aiChat'
	import {
		exportTargetReport
	} from "@/api/report"
	import {
		Message
	} from 'element-ui'
	import {
		nextTick
	} from 'vue'

	// ===== v-md-editor 核心导入 =====
	import VMdPreview from '@kangc/v-md-editor/lib/preview'
	import '@kangc/v-md-editor/lib/style/preview.css'
	import '@kangc/v-md-editor/lib/theme/style/vuepress.css'
	import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js'
	import Prism from 'prismjs'

	// Mermaid 插件
	import mermaid from 'mermaid'
	import createMermaidPlugin from '@kangc/v-md-editor/lib/plugins/mermaid/npm'
	import '@kangc/v-md-editor/lib/plugins/mermaid/mermaid.css'

	// 初始化 Mermaid，配合"失败不报错"的降级策略
	mermaid.initialize({
		startOnLoad: false,
		// 关键：禁止 mermaid 自己把错误渲染到 DOM 上
		suppressErrorRendering: true,
		theme: 'default',
		securityLevel: 'loose',
	})

	// 初始化主题
	VMdPreview.use(vuepressTheme, {
		Prism
	})

	// ===== 关键改造：包装 mermaid 插件 =====
	// createMermaidPlugin 内部会调用 mermaid.render，
	// 我们在这里做一层拦截：流式期间直接跳过，返回空内容占位。
	const mermaidPlugin = createMermaidPlugin(mermaid)

	// 如果插件导出的对象里带有渲染入口，可以做包装；
	// 更通用的做法是在 mermaid 自身渲染前拦截，见下方 wrapper。
	VMdPreview.use(mermaidPlugin)

	export default {
		name: "Famous",
		components: {
			VMdPreview
		},
		data() {
			return {
				id: '',
				params: {
					page: 1,
					pageSize: 20
				},
				loading: true,
				currentEventSource: null,
				isDone: false,
				fullContent: '',
			}
		},
		created() {
			this.initPageData();
		},
		beforeDestroy() {
			if (this.currentEventSource) {
				this.currentEventSource.close();
			}
		},
		methods: {
			initPageData() {
				this.tmpContent = '';
				this.streamData();
			},

			async streamData() {
				this.id = this.$route.query.id;
				this.params['id'] = this.id;
				this.isDone = false;

				try {
					await aiChatService.cozeStream('report/streamTargetReport', this.params, {
						onMessage: async (chunk) => {
							if (chunk['msg_type'] == 'delta') {
								this.tmpContent += chunk.content;
								let result = await this.resolveLastMermaid(this.tmpContent)
								if(result['renderable']){
									this.fullContent = this.tmpContent;
								}
								if (this.loading) {
									this.loading = false;
								}
							} else if (chunk['msg_type'] == 'completed') {
								this.fullContent = chunk.content;
								if (this.loading) {
									this.loading = false;
								}
								console.log(chunk.content)
							}
						},
						onComplete: (data) => {
							console.log('对话完成onComplete:', data);
							Message({
								message: '已分析完成',
								type: 'success'
							})
							if (this.loading) {
								this.loading = false;
							}
						},
						onError: (error) => {
							console.log('error', error)
							this.$message.error(error);
							this.isDone = true;
							if (this.loading) {
								this.loading = false;
							}
						},
						onDone: () => {
							console.log('对话完成onDone:');
							this.isDone = true;

						},
					});
				} catch (error) {
					console.error('对话异常:', error);
				}
			},
			
			async resolveLastMermaid(markdown) {
				const MERMAID_FENCE = '```mermaid';
				const FENCE = '```';
				
				// 1. 倒序找最后一个 ```mermaid
				const startIndex = markdown.lastIndexOf(MERMAID_FENCE);
				if (startIndex === -1) {
					return {
						found: false,
						code: '',
						closed: false,
						renderable: true,
						startIndex: -1
					};
				}
			
				// 2. 校验它确实位于行首（避免匹配到正文里的字样）
				const lineStart = markdown.lastIndexOf('\n', startIndex) + 1;
				if (markdown.slice(lineStart, startIndex).trim() !== '') {
					return {
						found: false,
						code: '',
						closed: false,
						renderable: true,
						startIndex: -1
					};
				}
			
				// 3. 从该位置往下找结束围栏 ```
				const codeStart = markdown.indexOf('\n', startIndex);
				if (codeStart === -1) {
					// 刚输出到 ```mermaid，还没有换行
					return {
						found: true,
						code: '',
						closed: false,
						renderable: false,
						startIndex
					};
				}
			
				const rest = markdown.slice(codeStart + 1);
				const closeIdx = rest.indexOf(FENCE);
			
				let code;
				let closed;
			
				if (closeIdx === -1) {
					// 未闭合：代码就是剩余全部
					code = rest;
					closed = false;
				} else {
					// 已闭合：切到结束围栏之前
					code = rest.slice(0, closeIdx);
					closed = true;
				}
			
				// 4. 已闭合 → 格式完整，直接渲染
				if (closed) {
					return {
						found: true,
						code,
						closed: true,
						renderable: true,
						startIndex
					};
				}
				
				let len = code.length;
				
				if (len < 30){
					return {
						found: false,
						code: '',
						closed: false,
						renderable: false,
						startIndex: -1
					};
				}
							
			
				// 5. 未闭合 → 尝试解析，能渲染就提前渲染
				const renderable = await this.canMermaidRender(code);
				if(renderable){
					console.log('renderable', renderable, 'code', code)
				}
				
				return {
					found: true,
					code,
					closed: false,
					renderable,
					startIndex
				};
			},
			
			async canMermaidRender(code) {
				if (!code.trim()) return false;
				try {
					const result = await mermaid.parse(code, {
						suppressErrors: true
					});
					return result !== false;
				} catch {
					return false;
				}
			},

			clickNext() {
				exportTargetReport(this.params).then(res => {
					let realData = res.data;
					window.open(realData.url, '_blank')
				})
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "target_report.scss";
</style>